import React from "react";
import { List, Avatar, Popover } from "antd";

const prettySize = (bytes) => {
  const kb = bytes / 1024;
  if (kb < 1024) {
    return Math.round(kb) + 'KB';
  }
  const mb = kb / 1024;
  return mb.toFixed(2) + 'MB';
};

export default class FileItem extends React.PureComponent {
  componentDidMount() {
    this.mounted = true;
    this.previewFile(this.props.file.originFileObj, previewDataUrl => {
      if (this.mounted) {
        this.props.file.thumbUrl = previewDataUrl;
        this.forceUpdate();
      }
    });
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  previewFile = (file, callback) => {
    const reader = new FileReader();
    reader.onloadend = () => callback(reader.result);
    reader.readAsDataURL(file);
  };

  onSelect = () => {
    this.props.onSelect(this.props.file);
  };

  renderPopover = () => {
    return (
      <div>
        <img
          src={this.props.file.thumbUrl}
          style={{ maxWidth: 600, maxHeight: 600 }}
        />
      </div>
    );
  };

  render() {
    const { style, file, actions } = this.props;
    return (
      <List.Item style={style} actions={actions}>
        <List.Item.Meta
          title={file.name}
          description={prettySize(file.size)}
          avatar={
            <Popover
              trigger={["hover"]}
              content={this.renderPopover()}
              placement="right"
            >
              <Avatar shape="square" src={file.thumbUrl} />
            </Popover>
          }
        />
      </List.Item>
    );
  }
}
